import gql from 'graphql-tag';

export const NAME = 'setup_ResourceErrorBoundary_dealerQuery';

export default gql`
  query ${NAME} (
    $dealerId: ID!,
  ) {
    dealer (
      id: $dealerId,
    ) {
      id
      name
      timezone
    }
  }
`;



// WEBPACK FOOTER //
// ./src/setup/ResourceErrorBoundary/dealerResourceCheckQuery.js